module.exports = __webpack_public_path__ + "media/ebs.c22d8669.mp4";